var $name="getDocumentDirection",$path="app/utilities/getDocumentDirection.js",$this={$name,$path,};import configs from 'configs';

const getDocumentDirection = () => document.dir || configs.directions.ltr;

export default getDocumentDirection;
